import { Button } from '../components/Common';

const SorryPage = () => {
    return (
        <div className="sorry-page">
            <img src="/svg/sorry-background.svg" alt="Background" className="sorry-page__background-image" />
            <img className="sorry-page__logo" src="/svg/auth/white-logo.svg" alt="white fornulio logo" />
            <img className="sorry-page__sorry-image" src="/svg/sorry.svg" alt="404 error" />
            <h1 className="sorry-page__title">Sorry... There was an error</h1>
            <p className="paragraph-3 sorry-page__text">
                We apologize for the inconvenience. In order to resolve this issue promptly, please reach out to us at&#160;
                <a className="paragraph-3 sorry-page__email" href="mailto:support@fornul.io">
                    support@fornul.io
                </a>
            </p>
            <p className="paragraph-3 sorry-page__text">Thank you for your understanding.</p>
            <Button className="sorry-page__button" text="Go to Homepage" onClick={() => (window.location.href = '/')}></Button>
        </div>
    );
};

export default SorryPage;
